<section class="mh-skills" id="rdm-skills">
    <div class="home-v-img">
        <div class="container">
            <div class="row section-separator">
                <div class="col-sm-12 col-md-6">
                    <div class="mh-skills-inner">
                        <div class="mh-professional-skill wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.3s">
                            <h3>Skills Técnicos</h3>
                            <div class="each-skills">
                                <div class="candidatos">
                                    <div class="parcial">
                                        <div class="info">
                                            <div class="nome">Node.JS</div>
                                            <div class="percentagem-num">100%</div>
                                        </div>
                                        <div class="progressBar">
                                            <div class="percentagem" style="width: 100%;"></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="candidatos">
                                    <div class="parcial">
                                        <div class="info">
                                            <div class="nome">Javascript</div>
                                            <div class="percentagem-num">100%</div>
                                        </div>
                                        <div class="progressBar">
                                            <div class="percentagem" style="width: 100%;"></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="candidatos">
                                    <div class="parcial">
                                        <div class="info">
                                            <div class="nome">Typescript</div>
                                            <div class="percentagem-num">100%</div>
                                        </div>
                                        <div class="progressBar">
                                            <div class="percentagem" style="width: 100%;"></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="candidatos">
                                    <div class="parcial">
                                        <div class="info">
                                            <div class="nome">Python</div>
                                            <div class="percentagem-num">90%</div>
                                        </div>
                                        <div class="progressBar">
                                            <div class="percentagem" style="width: 90%;"></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="candidatos">
                                    <div class="parcial">
                                        <div class="info">
                                            <div class="nome">Watson</div>
                                            <div class="percentagem-num">90%</div>
                                        </div>
                                        <div class="progressBar">
                                            <div class="percentagem" style="width: 90%;"></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="candidatos">
                                    <div class="parcial">
                                        <div class="info">
                                            <div class="nome">Angular</div>
                                            <div class="percentagem-num">90%</div>
                                        </div>
                                        <div class="progressBar">
                                            <div class="percentagem" style="width: 90%;"></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="candidatos">
                                    <div class="parcial">
                                        <div class="info">
                                            <div class="nome">IA</div>
                                            <div class="percentagem-num">80%</div>
                                        </div>
                                        <div class="progressBar">
                                            <div class="percentagem" style="width: 80%;"></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="candidatos">
                                    <div class="parcial">
                                        <div class="info">
                                            <div class="nome">.NET</div>
                                            <div class="percentagem-num">80%</div>
                                        </div>
                                        <div class="progressBar">
                                            <div class="percentagem" style="width: 80%;"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">
                    <div class="mh-professional-skills wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.5s">
                        <h3>Skills Profissionais</h3>
                        <ul class="mh-professional-progress">
                            <li>
                                <div class="mh-progress mh-progress-circle" data-progress="95"></div>
                                <div class="pr-skill-name">Comunicação</div>
                            </li>
                            <li>
                                <div class="mh-progress mh-progress-circle" data-progress="95"></div>
                                <div class="pr-skill-name">Trabalho em equipe</div>
                            </li>
                            <li>
                                <div class="mh-progress mh-progress-circle" data-progress="85"></div>
                                <div class="pr-skill-name">Liderança de Projetos</div>
                            </li>
                            <li>
                                <div class="mh-progress mh-progress-circle" data-progress="75"></div>
                                <div class="pr-skill-name">Criatividade</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>